import PropTypes from 'prop-types'

import { audioChatResetPeerStatus } from '../../actions/media'

const stateProps = {
  'features.audioChat': PropTypes.bool.isRequired,
  'audio.chatRequest': PropTypes.bool.isRequired,
  'audio.cancelByPeer': PropTypes.bool.isRequired,
}

/**
 * check if this modal should be displayed
 * @param {Object} state - the whole store state
 * @returns {Boolean} - true|false
 */
const shouldDisplay = ({
  features: { audioChat: audioChatFeature },
  audio: {
    chatRequest,
    cancelByPeer,
  }
}) => {
  return (audioChatFeature && !chatRequest && cancelByPeer)
}

/**
 * returns the modal data; this function is called
 * by AppModal only when this modal should be displayed
 * @param {Object} state - store state
 * @param {Function} dispatch - store dispatch
 * @param {Function} translate - i18n.t
 *
 * @returns {Object} - the modal data to be rendered by AppModal
 */
const getModalData = ({ dispatch }) => {
  const buttons = [
    {
      text: 'btn-close',
      onClick: () => dispatch(audioChatResetPeerStatus({ cancelByPeer: false }))
    },
  ]

  return {
    iconClass: 'modal-icon-audio-chat',
    title: 'chat-request-by-peer-cancelled-title',
    body: 'chat-request-by-peer-cancelled-text',
    buttons,
  }
}

export default {
  stateProps,
  shouldDisplay,
  getModalData,
}
